export default {
  // Common
  common: {
    app_code: 'dmp',
    collectedEvents: 'Sự Kiện Thu Thập',
    resetView: 'Đặt lại hiển thị',
    app_name: 'Du lịch DX Higashikawa',
    env_prod: '',
    env_prod_mobile: '',
    env_test: '【Môi trường test】',
    env_local: '【Môi trường local】',
    env_test_mobile: '[Test]',
    env_local_mobile: '[Local]',
    loading: 'Đang xử lý...',
    logout: 'Đăng Xuất',
    admin: 'Quản Trị',
    users: 'Người Dùng',
    userRegistrationRequests: 'Yêu cầu đăng ký người dùng',
    dataProviders: 'Nhà cung cấp dữ liệu',
    masterData: 'Dữ Liệu Chính',
    postalCodes: 'Mã Bưu Chính Chính',
    systemLogs: 'Nhật Ký Hệ Thống',
    language: 'Cài Đặt Ngôn Ngữ',
    changeLanguage: 'Thay Đổi Ngôn Ngữ',
    copyright: 'Copyright (C) Higashikawa Tourism DX Consortium',
    errorGeneral: 'Đã xảy ra lỗi. Vui lòng thử lại.',
    notSet: 'Chưa thiết lập',
    contact: 'Liên hệ',
    calendar: {
      weekdays: {
        sun: 'CN',
        mon: 'T2',
        tue: 'T3',
        wed: 'T4',
        thu: 'T5',
        fri: 'T6',
        sat: 'T7',
      },
    },
    error_dialog: {
      default_title: 'Lỗi',
      ok: 'OK'
    },
    info_dialog: {
      default_title: 'Thông tin',
      ok: 'OK'
    },
    warning_dialog: {
      default_title: 'Cảnh Báo',
      ok: 'OK'
    },
    confirm_dialog: {
      default_title: 'Xác Nhận',
      ok: 'OK',
      cancel: 'Hủy'
    },
  },

  // Header
  header: {
    welcomeMessage: 'Xin chào, ',
    nameTitle: ''
  },

  // Side Menu
  sideMenues: {
    home: 'Trang Chủ',
    events: 'Sự Kiện',
    accommodationBookings: 'Chỗ Ở',
    import: 'Nhập',
    export: 'Xuất',
    masterData: 'Dữ Liệu Chính',
    dataManagement: 'Quản Lý Dữ Liệu',
    donatorInformation: 'Thông Tin Người Quyên Góp',
    statisticData: 'Thống Kê',
    eventOrganizers: 'Nhà Tổ Chức Sự Kiện',
  },

  // Pagination
  pagination: {
    itemsPerPage: 'Số mục trên mỗi trang',
    itemsCount: '{count}',
    showing: 'Hiển thị {from} - {to} trong tổng số {total} mục',
    page: 'Trang',
    totalPages: '/ {total}',
    no_records: 'Không tìm thấy bản ghi phù hợp.',
    per_page: {
      '25': 'Hiển thị 25',
      '50': 'Hiển thị 50',
      '100': 'Hiển thị 100'
    }
  },

  // HTTP status error messages
  httpStatusMessages: {
    httpStatusTitle403: 'Truy Cập Bị Từ Chối',
    httpStatusMsg403: 'Bạn không có quyền xem trang này.\nBạn thiếu quyền cần thiết hoặc quyền truy cập bị hạn chế.',
    httpStatusTitle404: 'Không Tìm Thấy Trang',
    httpStatusMsg404: 'Trang không tồn tại hoặc URL không chính xác.',
    httpStatusTitle500: 'Lỗi Máy Chủ',
    httpStatusMsg500: 'Đã xảy ra lỗi máy chủ.\nVui lòng đợi một chút và thử lại.'
  },

  // Validation messages
  validation: {
    required: {
      currentPassword: 'Vui lòng nhập mật khẩu hiện tại.',
      newPassword: 'Vui lòng nhập mật khẩu mới.',
      confirmPassword: 'Vui lòng xác nhận mật khẩu mới.'
    },
    minLength: 'Mật khẩu mới phải có ít nhất 8 ký tự.',
    mismatch: 'Mật khẩu mới và mật khẩu xác nhận không khớp.',
    error: 'Không thể thay đổi mật khẩu.',
    password: {
      minLength: 'Mật khẩu phải có ít nhất 8 ký tự.',
      invalidCharacters: 'Mật khẩu phải có ít nhất 8 ký tự và bao gồm chữ hoa, chữ thường, số và ký hiệu (! . - _)',
      sameAsCurrentPassword: 'Mật khẩu mới không thể giống với mật khẩu hiện tại.'
    }
  },

  // Password change related
  password: {
    change: 'Thay Đổi Mật Khẩu',
    current: 'Mật Khẩu Hiện Tại',
    new: 'Mật Khẩu Mới',
    confirm: 'Xác Nhận Mật Khẩu Mới',
    button: 'Thay Đổi Mật Khẩu',
    cancel: 'Hủy',
    minLength: 'Vui lòng nhập tối thiểu 8 ký tự',
    success: 'Mật khẩu đã được thay đổi thành công.',
    failed: 'Không thể thay đổi mật khẩu.'
  },

  // Email change
  email: {
    change: 'Thay Đổi Địa Chỉ Email',
    current: 'Địa Chỉ Email Hiện Tại',
    new: 'Địa Chỉ Email Mới',
    button: 'Thay Đổi Địa Chỉ Email',
    cancel: 'Hủy',
    success: 'Yêu cầu thay đổi email đã được gửi. Email xác nhận đã được gửi đến địa chỉ email mới của bạn.',
    failed: 'Không thể thay đổi địa chỉ email.',
    confirmSuccess: 'Địa chỉ email đã được thay đổi thành công.',
    confirmFailed: 'Không thể xác nhận thay đổi email.',
    complete: {
      title: 'Hoàn Thành Thay Đổi Email',
      message: 'Địa chỉ email của bạn đã được thay đổi thành công. Vui lòng đăng nhập bằng địa chỉ email mới.',
      loginButton: 'Đến Trang Đăng Nhập',
      processing: 'Đang xử lý...',
      errorTitle: 'Đã Xảy Ra Lỗi',
      invalidToken: 'Token không hợp lệ.',
      tokenNotFound: 'Không tìm thấy token.',
      tokenExpired: 'Token đã hết hạn.',
      failed: 'Không thể thay đổi địa chỉ email.'
    },
    validation: {
      currentEmailRequired: 'Vui lòng nhập địa chỉ email hiện tại.',
      currentEmailInvalid: 'Định dạng địa chỉ email hiện tại không hợp lệ.',
      newEmailRequired: 'Vui lòng nhập địa chỉ email mới.',
      newEmailInvalid: 'Định dạng địa chỉ email mới không hợp lệ.',
      sameEmail: 'Địa chỉ email mới không thể giống với địa chỉ email hiện tại.'
    }
  },

  // Legal pages
  legal: {
    titleTermsOfUse: 'Điều khoản sử dụng',
    titlePrivacyPolicy: 'Chính sách bảo mật thông tin cá nhân',
    titleExternalTools: 'Thông báo công khai về các công cụ truyền tải bên ngoài',
  },

  // Authentication pages
  auth: {
    // Login page
    login: {
      title: 'Đăng Nhập',
      subtitle: 'Cổng Người Dùng',
      subtitle_admin: 'Portal Quản Lý Hệ Thống',
      email: 'Địa Chỉ Email',
      password: 'Mật Khẩu',
      remember: 'Duy trì đăng nhập',
      submit: 'Đăng Nhập',
      signupLink: 'Đăng ký mới',
      forgotPasswordLink: 'Quên mật khẩu?',
      forNewUserTitle: 'Dành cho người sử dụng lần đầu',
      forNewUserDescription: 'Việc sử dụng Du lịch DX Higashikawa yêu cầu đăng ký. Sau khi được phê duyệt, bạn sẽ có thể đăng nhập.',
      validation: {
        emailRequired: 'Vui lòng nhập địa chỉ email.',
        emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ.',
        passwordRequired: 'Vui lòng nhập mật khẩu.'
      },
      error: {
        invalid_credentials: 'Email hoặc mật khẩu không chính xác.',
        failed: 'Đăng nhập thất bại.'
      }
    },

    // Admin Login page
    adminLogin: {
      title: 'Web Quản trị DMP',
      email: 'Địa chỉ email',
      password: 'Mật khẩu',
      remember: 'Duy trì trạng thái đăng nhập',
      submit: 'Đăng nhập',
      authOidc: 'Xác thực Microsoft Entra ID',
      emailLoginNotice: 'Đăng nhập bằng địa chỉ email',
      forgotPasswordLink: 'Quên mật khẩu?',
      error: {
        failed: 'Đăng nhập Microsoft Entra ID thất bại.'
      }
    },

    activate_success: 'Kích hoạt tài khoản thành công.',
    logout_success: 'Đăng xuất thành công.',

    // Signup page
    signup: {
      title: 'Xin Đăng Ký Người Dùng',
      description: 'Việc sử dụng "Du lịch DX Higashikawa" yêu cầu phải đăng ký. Sau khi được phê duyệt, bạn sẽ có thể đăng nhập.',
      name: 'Tên Người Dùng',
      email: 'Địa Chỉ Email',
      officeName: 'Tên Cơ Sở',
      postalCode: 'Mã Bưu Điện',
      address: 'Địa Chỉ',
      phoneNumber: 'Số Điện Thoại',
      organization: 'Tổ Chức',
      selectOrganization: 'Vui lòng chọn tổ chức',
      organizations: {
        noOrganization: 'Không có tổ chức',
        tourAssociate: 'Hiệp Hội Du Lịch Higashikawa',
        chamberCommerce: 'Phòng Thương Mại Higashikawa'
      },
      submit: 'Xác Nhận',
      confirmTitle: 'Xác Nhận Thông Tin Đã Nhập',
      confirmDescription: 'Vui lòng kiểm tra thông tin bên dưới. Nếu đúng, vui lòng nhấp vào nút "Gửi Đơn".',
      register: 'Gửi Đơn',
      back: 'Quay Lại Để Sửa',
      loginLink: 'Đăng nhập tại đây',
      successTitle: 'Đã nhận đơn đăng ký',
      successMessage: 'Đơn đăng ký đã được tiếp nhận. Sau khi được phê duyệt, bạn sẽ nhận được email với hướng dẫn đăng ký.',
      backToLogin: 'Quay Lại Màn Hình Đăng Nhập',
      validation: {
        nameRequired: 'Vui lòng nhập tên người dùng.',
        nameMaxLength: 'Tên người dùng phải có 255 ký tự hoặc ít hơn.',
        emailRequired: 'Vui lòng nhập địa chỉ email.',
        emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ.',
        emailMaxLength: 'Địa chỉ email phải có 255 ký tự hoặc ít hơn.',
        officeNameRequired: 'Vui lòng nhập tên cơ sở.',
        officeNameMaxLength: 'Tên cơ sở phải có 255 ký tự hoặc ít hơn.',
        postalCodeRequired: 'Vui lòng nhập mã bưu điện.',
        postalCodeInvalid: 'Vui lòng nhập mã bưu điện theo định dạng "999-9999".',
        addressRequired: 'Vui lòng nhập địa chỉ.',
        addressMaxLength: 'Địa chỉ phải có 255 ký tự hoặc ít hơn.',
        phoneNumberRequired: 'Vui lòng nhập số điện thoại.',
        phoneNumberInvalid: 'Số điện thoại chỉ có thể nhập ký hiệu ' + ' (ký tự nửa rộng) và số nửa rộng, tối đa 15 chữ số.',
        organizationRequired: 'Vui lòng chọn tổ chức.'
      },
      agreePrefix: 'Tôi đồng ý với ',
      agreeConjunction: ' và ',
      agreeSuffix: ''
    },

    // Activate page
    activate: {
      title: 'Đăng Ký Chính Thức Người Dùng',
      description: 'Mật khẩu phải có ít nhất 8 ký tự và bao gồm chữ hoa, chữ thường, số và ký hiệu (! . - _)',
      password: 'Mật Khẩu',
      passwordConfirm: 'Xác Nhận Mật Khẩu',
      submit: 'Đăng Ký',
      loading: 'Đang tải thông tin người dùng...',
      successTitle: 'Hoàn Thành Đăng Ký Chính Thức',
      successMessage: 'Đăng ký người dùng đã hoàn thành.',
      goHome: 'Về Trang Chủ',
      errorTitle: 'Đã Xảy Ra Lỗi',
      backToLogin: 'Quay Lại Màn Hình Đăng Nhập',
      invalidToken: 'Liên kết không hợp lệ. Không tìm thấy token xác thực.',
      tokenExpired: 'Token không hợp lệ hoặc đã được sử dụng.',
      userNotFound: 'Không thể lấy thông tin người dùng.',
      activationFailed: 'Đăng ký chính thức thất bại.',
      validation: {
        passwordRequired: 'Vui lòng nhập mật khẩu.',
        passwordMinLength: 'Mật khẩu phải có ít nhất 8 ký tự.',
        passwordConfirmRequired: 'Vui lòng nhập xác nhận mật khẩu.',
        passwordMismatch: 'Mật khẩu không khớp.'
      }
    },

    // Forgot password page
    forgotPassword: {
      title: 'Đặt Lại Mật Khẩu',
      description1: 'Vui lòng nhập địa chỉ email đã đăng ký.',
      description2: 'Chúng tôi sẽ gửi email để đặt lại mật khẩu.',
      email: 'Địa Chỉ Email',
      submit: 'Gửi Email Xác Nhận',
      backToLogin: 'Quay Lại',
      success: 'Chúng tôi đã gửi email để đặt lại mật khẩu. Vui lòng kiểm tra email của bạn.',
      failed: 'Gửi email thất bại. Vui lòng đợi một chút và thử lại.',
      confirmTitle: 'Vui Lòng Kiểm Tra Email',
      confirmDescription1: 'Email đã được gửi đến ',
      confirmDescription2: 'Vui lòng đặt lại mật khẩu từ URL trong email.',
      validation: {
        emailRequired: 'Vui lòng nhập địa chỉ email.',
        emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ.'
      }
    },

    // Reset password page
    resetPassword: {
      title: 'Đặt Lại Mật Khẩu',
      description1: 'Vui lòng nhập mật khẩu mới.',
      description2: '* Mật khẩu phải có ít nhất 8 ký tự và bao gồm chữ hoa, chữ thường, số và ký hiệu (! . - _)',
      email: 'Địa Chỉ Email',
      password: 'Mật Khẩu Mới',
      passwordConfirm: 'Xác Nhận Mật Khẩu Mới',
      submit: 'Đặt Lại Mật Khẩu',
      backToLogin: 'Quay Lại Đăng Nhập',
      success: 'Đặt lại mật khẩu thành công.',
      failed: 'Đặt lại mật khẩu thất bại.',
      validation: {
        emailRequired: 'Vui lòng nhập địa chỉ email.',
        emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ.',
        passwordRequired: 'Vui lòng nhập mật khẩu.',
        passwordMinLength: 'Mật khẩu phải có ít nhất 8 ký tự.',
        passwordConfirmRequired: 'Vui lòng xác nhận mật khẩu.',
        passwordMismatch: 'Mật khẩu không khớp.',
        sameAsCurrentPassword: 'Mật khẩu mới không thể giống với mật khẩu hiện tại.'
      }
    }
  },

  // Data Providers (Laravel translation structure)
  // API Call Histories
  api_call_histories: {
    title: 'Tình trạng gọi API công khai',
    note: '* Số lượt gọi và mã trạng thái được tổng hợp theo từng hệ thống nguồn. Nội dung yêu cầu và phản hồi không được hiển thị.',
    days: '{days} ngày gần nhất',
    data_provider: 'Hệ thống nguồn',
    endpoint: 'Endpoint',
    method: 'Phương thức',
    status_code: 'Trạng thái',
    calls: 'Số lượt gọi',
    first_called_at: 'Lần gọi đầu',
    last_called_at: 'Lần gọi cuối',
    empty: 'Không có lượt gọi nào được ghi nhận trong khoảng thời gian này.',
    failures_title: 'Chi tiết các lượt gọi thất bại',
    failures_note: '* Chỉ hiển thị tên các trường bị từ chối. Giá trị đã gửi không được hiển thị.',
    message: 'Thông báo',
    rejected_fields: 'Trường bị từ chối',
    value_types_title: 'Kiểu của các giá trị bị từ chối',
    value_types_note: '* Tổng hợp từ 5 lượt thất bại gần nhất. Chỉ đọc kiểu của giá trị bị từ chối, không đọc giá trị.',
    value_type: 'Kiểu',
    occurrences: 'Số lần xuất hiện',
  },

  data_providers: {
    title: 'Nhà Cung Cấp Dữ Liệu',
    name: 'Tên',
    status: 'Trạng Thái',
    description: 'Mô Tả',
    register: 'Đăng Ký',
    edit: 'Chỉnh Sửa',
    delete: 'Xóa',
    details: 'Chi Tiết',

    // Status
    status_values: {
      active: 'Hoạt Động',
      inactive: 'Không Hoạt Động'
    },

    // Form
    form: {
      title: 'Đăng Ký Nhà Cung Cấp Dữ Liệu',
      edit_title: 'Chỉnh Sửa Nhà Cung Cấp Dữ Liệu',
      name_label: 'Tên',
      status_label: 'Trạng Thái',
      status_placeholder: 'Vui lòng chọn trạng thái',
      description_label: 'Mô Tả',
      register_button: 'Đăng Ký',
      update_button: 'Cập Nhật',
      cancel: 'Hủy',
      create_note: 'Quản lý token sẽ có sẵn trong màn hình chi tiết sau khi tạo.'
    },

    // Messages
    messages: {
      created: 'Đã đăng ký nhà cung cấp dữ liệu "{name}".',
      updated: 'Đã cập nhật nhà cung cấp dữ liệu "{name}".',
      deleted: 'Đã xóa nhà cung cấp dữ liệu "{name}".',
      confirm_delete: 'Bạn có chắc chắn muốn xóa không?'
    }
  },

  // Token Management
  tokens: {
    title: 'Quản Lý Token',
    generate_token: 'Tạo Token',
    personal_access_tokens: 'Token Truy Cập Cá Nhân',
    name: 'Tên',
    token_value: 'Giá Trị Token',
    abilities: 'Quyền',
    expires_at: 'Hết Hạn',
    created_at: 'Ngày Tạo',
    actions: 'Thao Tác',
    delete: 'Xóa',
    copy_token: 'Sao Chép Token',
    token_not_shown_after_creation: '（Token không hiển thị sau khi tạo）',
    never_expires: 'Không Hết Hạn',
    no_tokens: 'Không tìm thấy token.',

    // Messages
    messages: {
      token_generated: 'Token đã được tạo thành công.',
      token_deleted: 'Token đã được xóa thành công.',
      token_copied: 'Đã sao chép token vào clipboard.',
      copy_failed: 'Không thể sao chép token.',
      confirm_delete_token: 'Bạn có chắc chắn muốn xóa token này không?',
      enter_token_name: 'Vui lòng nhập tên token：',
      max_tokens_reached: 'Có thể tạo tối đa 10 token cho mỗi nhà cung cấp dữ liệu.'
    }
  },

  // Dashboard related
  dashboard: {
    title: 'Bảng Điều Khiển',
    subtitle: 'Theo dõi hàng ngày đặt phòng khách sạn, đặt sự kiện, xu hướng du khách, v.v.',
    tooltip: '選択中期間の宿泊予約またはイベント予約をしている訪問者数を集計',

    // Time periods
    periods: {
      yesterday: 'Ngày Hôm Trước',
      today: 'Hôm Nay',
      tomorrow: 'Ngày Mai'
    },

    // Statistics labels
    stats: {
      hotelBookings: 'Số Đặt Phòng Khách Sạn',
      eventBookings: 'Số Đặt Sự Kiện',
      eventsCount: 'Số Sự Kiện',
      hotelBookingsDesc: 'Số lượng đặt phòng, không phải số người dự kiến lưu trú',
      eventBookingsDesc: 'Số lượng đặt chỗ, không phải số người đặt sự kiện',
      eventsCountDesc: 'Ngày hôm trước là số thực tế, hôm nay hoặc ngày mai là số dự kiến'
    },

    // Chart
    chart: {
      title: 'Xu Hướng Khách Du Lịch',
      subtitle: 'Dự kiến và thực tế',
      thisYearVisitors: ' năm',
      lastYearVisitors: ' năm',
      period: {
        oneWeek: '1 Tuần',
        oneMonth: '1 Tháng',
        threeMonths: '3 Tháng'
      }
    },

    // Summary stats
    summary: {
      totalHotelBookings: 'Tổng Số Đặt Phòng Khách Sạn',
      totalEventBookings: 'Tổng Số Đặt Sự Kiện',
      totalEvents: 'Tổng Số Sự Kiện',
      avgDailyVisitors: 'Số Du Khách Trung Bình Hàng Ngày',
      periods: {
        threeDayTotal: 'Số dự kiến 3 ngày gần nhất bao gồm hôm nay',
        thirtyDayAverage: 'Trung bình 30 ngày qua'
      }
    },

    // Home page
    home: {
      title: 'Trang Chủ',
    },

    // Visitor Card
    visitor: {
      title: 'Số Du Khách',
      person_unit: 'người',
      year_label: 'Năm {year}',
      selected_period_label: 'Khoảng Thời Gian Đã Chọn',
      previous_year_same_period_label: 'Cùng Kỳ Năm Trước',
    },

    // Daily Visitor Card
    daily_visitor: {
      residential_area: 'Khu Vực Cư Trú',
      visitor: 'Du Khách',
      others: 'Khác',
      unanswered: 'Không Trả Lời',
      no_data: 'Không Có Dữ Liệu',
    },

    // Date Range Picker
    date_range: {
      cancel: 'Hủy',
      apply: 'Áp Dụng',
      alert: {
        max_range: 'Bạn có thể chọn khoảng thời gian tối đa {days} ngày.',
        select_dates: 'Vui lòng chọn ngày bắt đầu và ngày kết thúc.',
      },
    },

    // Repeat Visitors & Higashikawa Shareholder
    stats: {
      title_repeat_visitors: 'Khách Quay Lại',
      title_higashikawa_stockholder_visitors: 'Cổ Đông Higashikawa',
      number_unit: '%',
      trend_up: '↑',
      trend_down: '↓',
      trend_na: '± N/A (Không có dữ liệu năm trước)',
    },

    // Demographics
    demographics: {
      title_age_group: 'Độ Tuổi',
      title_gender: 'Giới Tính',
      age_group_less_20: '20 <',
      age_group_20: '20 < 30',
      age_group_30: '30 < 40',
      age_group_40: '40 < 50',
      age_group_50: '50 < 60',
      age_group_more_60: '60 <',
      age_group_unknown: 'Khác',
      gender_male: 'Nam',
      gender_female: 'Nữ',
      gender_unknown: 'Không Trả Lời',
    },

    // Occupancy Card
    occupancy: {
      title: 'Tỷ Lệ Lấp Đầy Chỗ Ở',
      subtitle: 'Số đặt phòng qua tomarin',
      detail_link: 'Chi tiết đặt phòng',
      occupancy_rate: 'Tỷ Lệ Lấp Đầy',
      total_rooms: 'Tổng Số Phòng',
      booked_rooms: 'Số Phòng Đã Đặt',
      rooms_unit: ' phòng',
      additional_note: '* Hiển thị tỷ lệ số phòng đã đặt qua tomarin so với tổng số phòng × số ngày trong khoảng thời gian đã chọn.',
      booked_rooms_label: 'Đã đặt',
      available_rooms_label: 'Trống',
    },

    // Crowd Level Calendar Card
    crowdLevelCalendar: {
      title: 'Tình Trạng Tổ Chức Sự Kiện',
      legend: {
        crowded: '100 người〜',
        crowdedBit: '50〜99 người',
        crowdedModerate: '1〜49 người',
        crowdedNone: '0 người',
      },
      modal: {
        title: 'Chi Tiết Sự Kiện',
        date: 'Ngày',
        totalEvents: 'Số Sự Kiện',
        eventCapacities: 'Sức Chứa Sự Kiện',
        eventParticipants: 'Số Người Tham Gia Sự Kiện',
        forecastedEventParticipants: 'Số Người Tham Gia Dự Kiến',
        unit: ' sự kiện',
        peopleUnit: ' người',
      },
    },

    // Events Combined Card
    events: {
      reservation_title: 'Số Đặt Sự Kiện',
      reservation_subtitle: 'Sự kiện tổ chức và số đặt chỗ',
      event_reservation_label: 'Đặt Sự Kiện',
      user_attributes: 'Thuộc Tính Người Dùng',
      shareholder: 'Cổ Đông Higashikawa',
      repeater: 'Khách Quay Lại',
      repeater_only: 'Khách Quay Lại Chỉ',
      stockholder_only: 'Cổ Đông Higashikawa Chỉ',
      both: 'Khách Quay Lại và Cổ Đông Higashikawa',
      other: 'Khác',
      total: 'Tổng Số',
      peopleUnit: ' người',
      booked_label: 'Đã đặt',
      available_label: 'Trống',
      total_capacity: 'Tổng số thực hiện sự kiện：{count} người',
      top_events: 'Sự Kiện Hàng Đầu',
      table: {
        event_name: 'Tên Sự Kiện',
        capacity: 'Sức Chứa',
        online: 'Trực Tuyến',
        organizer: 'Chủ Trì',
        date: 'Ngày Tổ Chức',
      },
      event_list_link: 'Danh sách sự kiện tổ chức',
      no_data: 'Không Có Dữ Liệu',
    },

    tooltips: {
      visitorCard: 'Chúng tôi đếm số lượng du khách đã đặt chỗ ở hoặc sự kiện trong khoảng thời gian đã chọn.',
      repeatVisitorCard: 'Đây là tỷ lệ phần trăm du khách quay lại trong khoảng thời gian đã chọn. Tỷ lệ thay đổi thể hiện so sánh với cùng kỳ năm trước. Do đếm riêng lẻ từng du khách trong khoảng thời gian, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
      higashikawaStockholderVisitorCard: 'Đây là tỷ lệ phần trăm du khách cổ đông Higashikawa trong khoảng thời gian đã chọn. Tỷ lệ thay đổi thể hiện so sánh với cùng kỳ năm trước. Do đếm riêng lẻ từng du khách trong khoảng thời gian, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
      ageGroupChartCard: 'Tổng hợp du khách trong khoảng thời gian đã chọn theo nhóm tuổi (không bao gồm các câu trả lời chưa có). Do phương pháp tổng hợp khác nhau, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
      genderChartCard: 'Tổng hợp du khách trong khoảng thời gian đã chọn theo giới tính (không bao gồm các câu trả lời chưa có). Do phương pháp tổng hợp khác nhau, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
      occupancyCard: 'Hiển thị tỷ lệ số phòng đã đặt qua tomarin so với tổng số phòng × số ngày trong khoảng thời gian đã chọn.',
      crowdLevelCalendarCard: 'Lịch được mã hóa màu dựa trên số lượng người tham gia sự kiện trong tháng mà ngày bắt đầu của khoảng thời gian được chọn thuộc về. Lưu ý rằng các sự kiện trực tuyến không được hiển thị trên lịch.',
      topEvents: '5 sự kiện có sức chứa lớn nhất sẽ được hiển thị trong số các sự kiện được lên lịch trong khoảng thời gian đã chọn trên lịch.',
    },

    // Repeat Visitor Detail Modal
    repeatVisitorDetail: {
      selectedPeriod: 'Khoảng Thời Gian Đã Chọn',
      previousYearPeriod: 'Khoảng Thời Gian Năm Trước',
      changeRate: 'Tỷ Lệ Thay Đổi',
      repeatVisitors: 'Khách Quay Lại: ',
      total: 'Tổng Số: ',
      personUnit: ' người',
      additionalNote: '* Do đếm riêng lẻ từng du khách trong khoảng thời gian, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
    },

    // Higashikawa Stockholder Visitor Detail Modal
    higashikawaStockholderVisitorDetail: {
      selectedPeriod: 'Khoảng Thời Gian Đã Chọn',
      previousYearPeriod: 'Khoảng Thời Gian Năm Trước',
      changeRate: 'Tỷ Lệ Thay Đổi',
      higashikawaStockholderVisitors: 'Khách Cổ Đông: ',
      total: 'Tổng Số: ',
      personUnit: ' người',
      additionalNote: '* Do đếm riêng lẻ từng du khách trong khoảng thời gian, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
    },

    // Age Group Visitor Detail Modal
    ageGroupVisitorDetail: {
      additionalNote: '* Do đếm riêng lẻ từng du khách trong khoảng thời gian, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
      peopleUnit: ' người',
    },

    // Gender Visitor Detail Modal
    genderVisitorDetail: {
      additionalNote: '* Do đếm riêng lẻ từng du khách trong khoảng thời gian, tổng số người có thể không khớp với biểu đồ xu hướng du khách.',
      peopleUnit: ' người',
    },
  },

  // Master Data
  guestDemographics: {
    age_less_20: '〜20',
    age_20: '20〜30',
    age_30: '30〜40',
    age_40: '40〜50',
    age_50: '50〜60',
    age_more_60: '60〜',
    age_other: 'Khác',
    male: 'Nam',
    female: 'Nữ',
    no_answer: 'Không Trả Lời',
  },
  eventDetail: {
    edit: 'Chỉnh Sửa',
    eventDate: 'Ngày Tổ Chức',
    fee: 'Phí Tham Gia',
    capacity: 'Sức Chứa',
    peopleUnit: ' người',
    currencyUnit: ' yên',
    dateFormat: '{day}/{month}/{year}',
    bookingRate: 'Lượt Đặt Chỗ',
    accommodationGuests: 'Khách Lưu Trú Trong Thị Trấn',
    repeaters: 'Khách Quay Lại',
    stockholders: 'Cổ Đông Higashikawa',
    ageGroups: 'Nhóm Tuổi',
    genders: 'Giới Tính',
    genderNoAnswer: 'Không Trả Lời',
    residentialAreas: 'Khu Vực Cư Trú',
    distributionComparison: 'So Sánh Phân Bố',
    participants: 'Người tham gia',
    allEvents: 'Tất cả sự kiện',
    showMore: 'Xem thêm',
    showLess: 'Thu gọn',
    noData: 'Không có dữ liệu',
    loading: 'Đang tải...',
    notFound: 'Không tìm thấy sự kiện',
  },
  accommodationSummary: {
    title: 'Lưu Trú',
    bookings: 'Lượt Đặt Phòng',
    bookingsSubtitle: 'Xu hướng đặt phòng qua tomarin',
    help: 'Hiển thị dữ liệu đặt phòng lưu trú trong kỳ đã chọn, theo lần tổng hợp hằng ngày gần nhất.',
    resetView: 'Đặt lại hiển thị',
    peopleUnit: ' người',
    selectedPeriod: 'Kỳ đã chọn',
    previousYearPeriod: 'Cùng kỳ năm trước',
    occupancy: 'Công Suất Phòng',
    repeaters: 'Khách Lưu Trú Quay Lại',
    stockholders: 'Cổ Đông Higashikawa',
    ageGroups: 'Nhóm Tuổi',
    genders: 'Giới Tính',
    genderNoAnswer: 'Không Trả Lời',
    residentialAreas: 'Khu Vực Cư Trú',
    noData: 'Không có dữ liệu',
  },
  collectedEvents: {
    tabSources: 'Nguồn',
    sourceUrl: 'URL',
    sourceMethod: 'Phương Thức',
    sourceTotal: 'Tổng Thu Thập',
    sourceLastRun: 'Lần Chạy Cuối',
    sourceNeverRun: 'Chưa chạy',
    sourceOk: 'Thành công',
    sourceFailed: 'Thất bại',
    category: 'Danh Mục',
    collectNow: 'Thu thập ngay',
    collectErrors: 'Nguồn bị lỗi',
    collectFailed: 'Thu thập thất bại.',
    title: 'Sự Kiện Thu Thập',
    description: 'Các sự kiện được thu thập tự động mỗi sáng từ những trang web trong thị trấn. Hãy kiểm tra rồi đăng ký, hoặc đánh dấu là không phù hợp. Sự kiện đã đăng ký được tạo ở trạng thái nháp.',
    source: 'Nguồn',
    eventTitle: 'Tên Sự Kiện',
    period: 'Ngày Tổ Chức',
    venue: 'Địa Điểm',
    actions: 'Thao Tác',
    approve: 'Đăng ký',
    reject: 'Bỏ qua',
    approveTitle: 'Đăng Ký Thành Sự Kiện',
    approveNote: 'Nội dung thu thập được trích xuất tự động nên có thể có sai sót. Vui lòng kiểm tra và chỉnh sửa trước khi đăng ký.',
    approveSubmit: 'Đăng ký',
    approveFailed: 'Đăng ký thất bại.',
    cancel: 'Hủy',
    startDate: 'Ngày Bắt Đầu',
    endDate: 'Ngày Kết Thúc',
    capacity: 'Sức Chứa',
    feeAmount: 'Phí (yên)',
    feeSource: 'Theo dữ liệu thu thập',
    descriptionLabel: 'Mô Tả',
    statusPending: 'Chờ duyệt',
    statusApproved: 'Đã đăng ký',
    statusRejected: 'Đã bỏ qua',
    loading: 'Đang tải...',
    empty: 'Không có sự kiện phù hợp',
  },
  adminDashboard: {
    pendingRequests: 'Yêu Cầu Đăng Ký Chờ Phê Duyệt',
    errors24h: 'Lỗi Trong 24 Giờ Qua',
    countUnit: '',
    errorsBreakdown: 'API Công Khai: {api} / Thao Tác: {operation}',
    providersTitle: 'Hoạt Động Nhà Cung Cấp Dữ Liệu',
    providerName: 'Tên Nhà Cung Cấp',
    lastCalledAt: 'Nhận Lần Cuối',
    calls24h: 'Lượt Gọi (24h)',
    providerErrors24h: 'Lỗi (24h)',
    neverCalled: 'Chưa từng nhận',
    noProviders: 'Không có nhà cung cấp dữ liệu',
    tablesTitle: 'Số Lượng Dữ Liệu Chính',
    loading: 'Đang tải...',
  },
  masterData: {
    title: 'Danh Sách Dữ Liệu Chính',
    detailTitle: 'Chi Tiết Dữ Liệu Chính',
    tableNameHeader: 'Tên Bảng',
    rowCountHeader: 'Số Hàng',
    lastUpdatedHeader: 'Cập Nhật Cuối',
    loading: 'Đang tải...',
    noTablesFound: 'Không tìm thấy bảng nào',
    filters: {
      createdDate: 'Ngày Tạo',
      updatedDate: 'Ngày Cập Nhật',
      searchButton: 'Tìm Kiếm',
      filterStart: 'Điểm Bắt Đầu Lọc',
      filterEnd: 'Điểm Kết Thúc Lọc',
      toggleIncludeDeleted: 'Bao Gồm Đã Xóa'
    },
  },

  // Accommodation Bookings
  accommodationBookings: {
    title: 'Danh Sách Đặt Phòng',
    loading: 'Đang tải...',
    noBookingsFound: 'Không tìm thấy đặt phòng nào',
    filters: {
      checkinDate: 'Ngày Nhận Phòng',
      checkoutDate: 'Ngày Trả Phòng',
      status: 'Trạng Thái',
      allStatus: 'Tất Cả Trạng Thái',
      searchButton: 'Tìm Kiếm',
      filterStart: 'Ngày Bắt Đầu',
      filterEnd: 'Ngày Kết Thúc'
    },
    status: {
      confirmed: 'Đã Xác Nhận',
      cancelled: 'Đã Hủy',
      pending: 'Đang Chờ'
    },
    table: {
      id: 'ID',
      hotelName: 'Tên Cơ Sở Lưu Trú',
      checkinDate: 'Ngày Nhận Phòng',
      checkoutDate: 'Ngày Trả Phòng',
      guestCount: 'Số Người Lưu Trú',
      hasMeal: 'Có Bữa Ăn',
      hasEventGuests: 'Có/Không Đặt Sự Kiện',
      totalPrice: 'Tổng Tiền',
      status: 'Trạng Thái',
      createdAt: 'Ngày Giờ Tạo'
    },
    csvExport: {
      button: 'Xuất CSV',
      title: 'Xuất CSV',
      message: 'Xuất {count} kết quả tìm kiếm ra CSV.',
      encodingLabel: 'Mã Hóa',
      cancel: 'Hủy',
      export: 'Xuất',
      exporting: 'Đang xuất...'
    }
  },

  // Postal Codes
  postalCodes: {
    title: 'Mã Bưu Chính Master',
    csvImport: 'Nhập CSV',
    importing: 'Đang nhập...',
    importComplete: 'Hoàn Thành Nhập',
    importCount: 'Số lượng nhập: {count} mục',
    errors: 'Lỗi:',
    moreErrors: '...và {count} mục khác',
    table: {
      postalCode: 'Mã Bưu Chính',
      prefecture: 'Tỉnh',
      city: 'Thành Phố/Quận',
      area: 'Khu Vực',
      prefectureKana: 'Tỉnh（Kana）',
      cityKana: 'Thành Phố/Quận（Kana）',
      areaKana: 'Khu Vực（Kana）'
    },
    importModal: {
      title: 'Nhập Tệp CSV',
      fileLabel: 'Vui lòng chọn tệp CSV',
      fileHelp: 'Vui lòng tải lên tệp ken_all.csv của Bưu điện Nhật Bản（mã hóa Shift-JIS）.',
      cancel: 'Hủy',
      import: 'Nhập'
    }
  },

  // Import
  import: {
    ledghome: {
      title: 'Nhập khẩu > Thông tin người đóng góp',
      description: 'Bạn có thể nhập tệp CSV "寄附者情報" được xuất từ LedgHome',
      dropMessage: 'Nhấp vào đây để chọn tệp hoặc\nkéo và thả tệp',
      importButton: 'Nhập',
      importing: 'Đang nhập...',
      maxFilesError: 'Bạn có thể tải lên tối đa {max} tệp',
      importError: 'Nhập thất bại',
      results: {
        title: 'Kết Quả Nhập',
        titleSuccess: 'Nhập Hoàn Tất',
        titleWithErrors: 'Nhập Hoàn Tất (Có Lỗi)',
        totalFiles: 'Tổng Số Tệp',
        processedFiles: 'Số Tệp Đã Xử Lý',
        totalRows: 'Tổng Số Hàng',
        createdDonators: 'Người Quyên Góp Đã Tạo',
        updatedDonators: 'Người Quyên Góp Đã Cập Nhật',
        createdStockholders: 'Cổ Đông Đã Tạo',
        updatedStockholders: 'Cổ Đông Đã Cập Nhật',
        deletedStockholders: 'Cổ Đông Đã Xóa',
        errors: 'Lỗi'
      }
    },
    messages: {
      data_provider_not_found: 'Không tìm thấy nhà cung cấp dữ liệu',
      import_completed: 'Nhập hoàn tất',
      import_failed: 'Nhập thất bại',
      donator_number_required: 'Số người quyên góp là bắt buộc'
    },
    validation: {
      files_required: 'Vui lòng chọn tệp',
      files_array: 'Tệp phải là một mảng',
      files_max: 'Bạn có thể tải lên tối đa 10 tệp',
      file_required: 'Tệp là bắt buộc',
      file_type: 'Loại tệp không hợp lệ',
      file_mimes: 'Chỉ có thể tải lên tệp CSV (.csv, .txt)',
      file_size_max: 'Kích thước tệp phải nhỏ hơn 50MB'
    }
  },

  // Events
  events: {
    titleList: 'Danh Sách Sự Kiện',
    helpTooltip: 'Hiển thị các sự kiện đã lên lịch trong khoảng thời gian đã chọn',
    eventName: 'Tên Sự Kiện',
    capacity: 'Sức Chứa',
    isOnline: 'Trực Tuyến',
    organizer: 'Nhà Tổ Chức',
    eventDate: 'Ngày',
    fee: 'Phí',
    noData: 'Không có dữ liệu',
    loading: 'Đang tải...',
    additionalOrganizers: '+{count} khác',
  },

  // Event Organizers
  eventOrganizers: {
    title: 'Nhà Tổ Chức Sự Kiện',
    titleList: 'Dữ Liệu Chính',
    edit: 'Chỉnh Sửa',
    create: 'Tạo',
    search: 'Tìm Kiếm',
    searchPlaceholder: 'Tìm kiếm theo tên nhà tổ chức...',
    addNew: 'Thêm Mới',
    organizer: 'Nhà Tổ Chức',
    organizerName: 'Tên Nhà Tổ Chức',
    phoneMain: 'Số Điện Thoại (Chính)',
    phoneSub: 'Số Điện Thoại (Phụ)',
    emailMain: 'Email (Chính)',
    emailSub: 'Email (Phụ)',
    address: 'Địa Chỉ',
    postalCode: 'Mã Bưu Điện',
    postalCodePlaceholder: '888-8888',
    prefecture: 'Tỉnh',
    prefectureDefault: 'Vui lòng chọn',
    city: 'Thành Phố',
    cityPlaceholder: 'Kamikawa-gun Higashikawa-cho',
    cityDetail: 'Chi Tiết Địa Chỉ',
    cityDetailPlaceholder: '1-1-1',
    building: 'Tòa Nhà',
    buildingPlaceholder: 'Sentopure',
    delete: 'Xóa',
    cancel: 'Hủy',
    update: 'Cập Nhật',
    noData: 'Không có dữ liệu',
    loading: 'Đang tải...',
    required: 'Bắt buộc',
    confirmDelete: 'Bạn có chắc chắn muốn xóa? Hành động này không thể hoàn tác.',
    errorFetchData: 'Không thể tải dữ liệu',
    successUpdate: 'Cập nhật nhà tổ chức thành công',
    successCreate: 'Tạo nhà tổ chức thành công',
    errorSave: 'Lưu thất bại',
    successDelete: 'Xóa nhà tổ chức thành công',
    errorDelete: 'Xóa thất bại',
    errorDeleteInUse: 'Nhà tổ chức sự kiện này đã được sử dụng trong các sự kiện và không thể xóa. Vui lòng xóa nhà tổ chức khỏi sự kiện trước.',
    validation: {
      nameRequired: 'Vui lòng nhập tên nhà tổ chức',
      nameMaxLength: 'Tên nhà tổ chức phải có 255 ký tự hoặc ít hơn',
      phoneInvalid: 'Số điện thoại chỉ được chứa chữ số và dấu gạch ngang (-)',
      phoneMaxLength: 'Số điện thoại phải có 20 ký tự hoặc ít hơn',
      emailInvalid: 'Vui lòng nhập địa chỉ email hợp lệ',
      emailMaxLength: 'Địa chỉ email phải có 255 ký tự hoặc ít hơn',
      postalCodeRequired: 'Vui lòng nhập mã bưu điện',
      postalCodeInvalid: 'Mã bưu điện phải có định dạng 999-9999',
      postalCodeMaxLength: 'Mã bưu điện phải có 10 ký tự hoặc ít hơn',
      prefectureRequired: 'Vui lòng chọn tỉnh',
      cityRequired: 'Vui lòng nhập thành phố',
      cityMaxLength: 'Thành phố phải có 100 ký tự hoặc ít hơn',
      townMaxLength: 'Chi tiết địa chỉ phải có 100 ký tự hoặc ít hơn',
      buildingMaxLength: 'Tên tòa nhà phải có 200 ký tự hoặc ít hơn'
    },
    messages: {
      fetchFailed: 'Không thể tải dữ liệu',
      updated: 'Cập nhật nhà tổ chức thành công',
      created: 'Tạo nhà tổ chức thành công',
      saveFailed: 'Lưu thất bại',
      deleted: 'Xóa nhà tổ chức thành công',
      deleteFailed: 'Xóa thất bại'
    }
  },

  // Master Events
  masterEvents: {
    title: 'Sự Kiện',
    titleList: 'Dữ Liệu Chính',
    searchPlaceholder: 'Tìm kiếm theo tên sự kiện...',
    addNew: 'Thêm Mới',
    eventName: 'Tên Sự Kiện',
    description: 'Mô Tả',
    startDate: 'Ngày Bắt Đầu',
    endDate: 'Ngày Kết Thúc',
    capacity: 'Sức Chứa',
    forecastedVisitorCount: 'Số lượng khách dự kiến',
    isOnline: 'Trực Tuyến',
    organizer: 'Nhà Tổ Chức',
    feeMax: 'Phí (Tối Đa)',
    feeMin: 'Phí (Tối Thiểu)',
    noData: 'Không có dữ liệu',
    loading: 'Đang tải...',
    edit: 'Chỉnh Sửa',
    create: 'Tạo',
    createButton: 'Tạo',
    update: 'Cập Nhật',
    cancel: 'Hủy',
    delete: 'Xóa',
    organizers: 'Nhà Tổ Chức',
    fees: 'Phí',
    selectOrganizer: 'Chọn nhà tổ chức',
    isPrimary: 'Chính',
    addOrganizer: 'Thêm nhà tổ chức',
    feeType: 'Loại phí',
    feeAmount: 'Số tiền',
    feeDescription: 'Mô tả',
    addFee: 'Thêm phí',
    confirmDelete: 'Bạn có chắc chắn muốn xóa sự kiện này?',
    successUpdate: 'Cập nhật sự kiện thành công',
    successCreate: 'Tạo sự kiện thành công',
    successDelete: 'Xóa sự kiện thành công',
    errorFetchData: 'Không thể tải dữ liệu',
    errorSave: 'Không thể lưu',
    errorDelete: 'Không thể xóa',
    errorDeleteInUse: 'Không thể xóa sự kiện này vì có dữ liệu đặt chỗ liên quan.',
    // Image upload section
    addImage: 'Thêm Ảnh',
    imageCountHint: 'Tối đa 5 ảnh',
    analyzing: 'Đang phân tích bằng AI...',
    analyzeWithAI: 'Phân tích bằng AI',
    // Event form
    eventNumber: 'Sự kiện {n}',
    organizerTooltip: 'Chọn nhà tổ chức đã đăng ký trong dữ liệu chính nhà tổ chức sự kiện',
    searchOrganizer: 'Tìm kiếm nhà tổ chức...',
    dateRange: 'Thời gian sự kiện',
    currencyYen: '¥{amount}',
    capacityWithHint: 'Sức chứa',
    capacityUnit: 'người',
    forecastedVisitorCount: 'Số lượng khách dự kiến',
    onlineEvent: 'Sự kiện trực tuyến',
    deleteEvent: 'Xóa sự kiện',
    addEventInput: 'Thêm biểu mẫu sự kiện',
    participationFee: 'Phí tham gia',
    // Messages
    analyzeSuccess: 'Phân tích tờ rơi sự kiện hoàn tất',
    successCreateBulk: 'Đã tạo {count} sự kiện',
    errorNoFilesToAnalyze: 'Không có ảnh để phân tích',
    errorAnalyze: 'Không thể phân tích tờ rơi sự kiện',
    validation: {
      titleRequired: 'Vui lòng nhập tên sự kiện',
      titleMaxLength: 'Tên sự kiện phải có 255 ký tự hoặc ít hơn',
      startDateRequired: 'Vui lòng nhập ngày bắt đầu',
      endDateRequired: 'Vui lòng nhập ngày kết thúc',
      endDateAfterStart: 'Ngày kết thúc phải bằng hoặc sau ngày bắt đầu',
      organizerRequired: 'Vui lòng thêm ít nhất một nhà tổ chức',
      organizerSelectRequired: 'Vui lòng chọn nhà tổ chức',
      feeTypeRequired: 'Vui lòng nhập loại phí',
      feeAmountRequired: 'Vui lòng nhập số tiền',
      organizerDuplicate: 'Cùng một nhà tổ chức được chọn nhiều lần',
      feeTypeDuplicate: 'Cùng một loại phí được đặt nhiều lần',
      forecastedVisitorCountRequired: 'Số lượng khách dự kiến là bắt buộc khi không nhập sức chứa'
    }
  },

  // Export
  export: {
    statisticData: {
      title: 'Xuất > Thống Kê',
      description: 'Bạn có thể xuất các dữ liệu thống kê khác nhau được tạo bởi dịch vụ này',
      periodLabel: 'Khoảng Thời Gian Tổng Hợp',
      dataTypeLabel: 'Loại Dữ Liệu',
      dataTypes: {
        statistic_summaries: 'Thống Kê Tổng Hợp',
        statistic_visitor_attributes: 'Thuộc Tính Du Khách',
        statistic_visitor_accommodation_bookings: 'Thống Kê Chỗ Ở',
        statistic_visitor_event_bookings: 'Thống Kê Sự Kiện'
      },
      encodingLabel: 'Định Dạng Dữ Liệu Xuất',
      encodings: {
        sjis: 'Shift-JIS',
        utf8: 'UTF-8'
      },
      exportButton: 'Xuất',
      exporting: 'Đang xuất...',
      errors: {
        select_data_type: 'Vui lòng chọn loại dữ liệu',
        select_encoding: 'Vui lòng chọn định dạng dữ liệu xuất',
        max_days: 'Vui lòng chỉ định khoảng thời gian trong vòng 100 ngày',
        invalid_date_range: 'Ngày kết thúc phải sau ngày bắt đầu',
        no_permission: 'Bạn không có quyền thao tác CSV',
        export_failed: 'Xuất CSV thất bại',
        invalid_data: 'Dữ liệu đầu vào không chính xác'
      },
      warnings: {
        not_implemented: 'Không thể xuất vì hiện đang được triển khai',
      },
      tooltips: {
        dateRange: 'Được sử dụng để lọc theo ngày tham chiếu của các thống kê được tạo hàng ngày. Bạn có thể chọn tối đa 100 ngày trong khoảng dữ liệu thống kê đã tạo.',
        encodingType: 'Theo nguyên tắc chung, người dùng Windows nên sử dụng Shift-JIS, và người dùng MacOS nên sử dụng UTF-8. Nếu các ký tự hiển thị bị lỗi, vui lòng kiểm tra cài đặt mã hóa của ứng dụng bạn đang sử dụng trong môi trường của mình.',
      }
    }
  }
};
